module.exports = __webpack_public_path__ + "static/media/0021.ec64fe8e.jpg";